import Tooltip from 'components/library/Tooltip/Tooltip';
import HelpIconMaterial from 'components/library/Icons/HelpIconMaterial';
import React from 'react';
import { i18n } from 'utils/translate';

export default function GeoHelpTooltip() {
    return (
        <Tooltip
            content={
                <>
                    {i18n('tooltip_geotargeting')}
                    <br />
                    <a
                        className="learn-more"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://help.thribee.com/hc/en-us/articles/115003682394-Geotargeting"
                    >
                        {i18n('learn_more_help_center')}
                    </a>
                </>
            }
            placement="right"
        >
            <HelpIconMaterial />
        </Tooltip>
    );
}
